// Copyright (c) 2020 Verimatrix, Inc.  All Rights Reserved.

import {GET_BUILD_ID} from '../actions/app'

const initialState = {
  buildId: null
}

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_BUILD_ID:
      return {...state, buildId: action.payload}
    default:
      return state
  }
}
